import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../supabaseClient'
import Footer from '../components/Footer'
import { v4 as uuidv4 } from 'uuid'

export default function EditProject() {
  const { id } = useParams()
  const navigate = useNavigate()

  const [project, setProject] = useState({
    title: '',
    description: '',
    role: '',
    start_date: '',
    end_date: '',
    image_url: ''
  })
  const [imageFile, setImageFile] = useState(null)
  const [imagePreview, setImagePreview] = useState(null)
  const [loading, setLoading] = useState(false)

  // Ambil data project berdasarkan ID
  useEffect(() => {
    const fetchProject = async () => {
      const { data, error } = await supabase
        .from('projects')
        .select('*')
        .eq('project_id', id)
        .single()

      if (error) {
        console.error(error)
      } else {
        setProject(data)
      }
    }

    fetchProject()
  }, [id])

  // Handler untuk form
  const handleChange = (e) => {
    const { name, value } = e.target
    setProject((prev) => ({ ...prev, [name]: value }))
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setImageFile(file)
      setImagePreview(URL.createObjectURL(file))
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    let imageUrl = project.image_url

    if (imageFile) {
      const fileExt = imageFile.name.split('.').pop()
      const fileName = `${uuidv4()}.${fileExt}`
      const filePath = `${fileName}`

      const { error: uploadError } = await supabase.storage
        .from('project-images')
        .upload(filePath, imageFile, {
          cacheControl: '3600',
          upsert: false
        })

      if (uploadError) {
        console.error(uploadError)
        setLoading(false)
        return
      }

      const { data: publicUrlData } = supabase.storage
        .from('project-images')
        .getPublicUrl(filePath)

      imageUrl = publicUrlData.publicUrl
    }

    // Simpan update ke Supabase
    const { error } = await supabase
      .from('projects')
      .update({
        title: project.title,
        description: project.description,
        role: project.role,
        start_date: project.start_date,
        end_date: project.end_date,
        image_url: imageUrl
      })
      .eq('project_id', id)

    setLoading(false)

    if (error) {
      console.error(error)
    } else {
      navigate('/dashboard')
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 p-4 sm:p-6 lg:p-8">
      <div className="max-w-3xl mx-auto p-8 bg-white rounded-xl shadow-md">
        <h2 className="text-3xl font-bold text-slate-800 mb-6 border-b pb-2">Edit Project</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-slate-700 font-medium mb-1">
            Nama Project <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="title"
            value={project.title}
            onChange={handleChange}
            placeholder="Nama project"
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label className="block text-slate-700 font-medium mb-1">
            Role/Posisi <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="role"
            value={project.role}
            onChange={handleChange}
            placeholder="Contoh: Full Stack Developer"
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-slate-700 font-medium mb-1">
              Tanggal Mulai <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none z-10 hidden sm:block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <input
                type="date"
                name="start_date"
                value={project.start_date}
                onChange={handleChange}
                className="w-full pl-3 sm:pl-10 pr-3 py-2 text-sm border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[44px] bg-white"
                required
              />
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none sm:hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
          <div>
            <label className="block text-slate-700 font-medium mb-1">
              Tanggal Selesai <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none z-10 hidden sm:block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <input
                type="date"
                name="end_date"
                value={project.end_date}
                onChange={handleChange}
                className="w-full pl-3 sm:pl-10 pr-3 py-2 text-sm border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[44px] bg-white"
                required
              />
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none sm:hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
        </div>

        <div>
          <label className="block text-slate-700 font-medium mb-1">
            Deskripsi Project <span className="text-red-500">*</span>
          </label>
          <textarea
            name="description"
            value={project.description}
            onChange={handleChange}
            rows="5"
            placeholder="Deskripsi lengkap project"
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label className="block text-slate-700 font-medium mb-1">
            Upload Gambar Project <span className="text-slate-500 text-sm">(Opsional)</span>
          </label>
          
          {/* Current Image or Preview */}
          {(imagePreview || project.image_url) && (
            <div className="mb-3 relative">
              <img
                src={imagePreview || project.image_url}
                alt="Preview"
                className="w-full h-64 object-cover rounded-lg border border-slate-200"
              />
              {imagePreview && (
                <button
                  type="button"
                  onClick={() => {
                    setImageFile(null)
                    setImagePreview(null)
                  }}
                  className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>
          )}
          
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
          />
        </div>

        <div className="flex justify-between items-center mt-8 pt-6 border-t">
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="px-6 py-2 border border-slate-400 text-slate-700 rounded-lg hover:bg-slate-50 transition font-medium"
            disabled={loading}
          >
            Batal
          </button>
          <button
            type="submit"
            className={`px-8 py-2 rounded-lg text-white transition font-semibold ${
              loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 shadow-md hover:shadow-sm'
            }`}
            disabled={loading}
          >
            {loading ? 'Menyimpan...' : 'Simpan Perubahan'}
          </button>
        </div>
      </form>
      </div>
      <Footer />
    </div>
  )
}
